import { notify } from '@p2p/components';
import { copyToClipboard } from '@p2p/shared/functions';
import classNames from 'classnames';
import { forwardRef } from 'react';

import type { RequisiteRow } from '../TransferInvoicePage/components';
import styles from './AlfaQrInvoice.module.scss';
import { ChevronDownIcon, CopyFieldIcon } from './icons';

type AlfaRequisitesProps = {
  rows: RequisiteRow[];
  isOpen: boolean;
  onToggle: () => void;
};

const copyWithNotice = async (text: string, title: string) => {
  const ok = await copyToClipboard(text);

  notify(
    ok
      ? { type: 'success', title, timer: 2000 }
      : { type: 'error', title: 'Не удалось скопировать', timer: 2000 },
  );
};

/** P2P-3116: карточка «Оплата по реквизитам» (аккордеон) - копирование каждого поля и всех сразу. */
export const AlfaRequisites = forwardRef<HTMLElement, AlfaRequisitesProps>(
  ({ rows, isOpen, onToggle }, ref) => (
    <section ref={ref} className={classNames(styles.card, styles.requisites)}>
      <button
        type="button"
        className={styles.requisitesHead}
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        Оплата по реквизитам
        <ChevronDownIcon className={classNames(styles.chevron, { [styles.chevronOpen]: isOpen })} />
      </button>
      {isOpen && (
        <div className={styles.requisitesBody}>
          {rows.map((row) => (
            <div className={styles.field} key={row.label}>
              <div>
                <small>{row.label}</small>
                <span>{row.value}</span>
              </div>
              <button
                type="button"
                className={styles.copyButton}
                aria-label={`Скопировать: ${row.label}`}
                onClick={() => copyWithNotice(row.value, `${row.label}: скопировано`)}
              >
                <CopyFieldIcon />
              </button>
            </div>
          ))}
          <button
            type="button"
            className={classNames(styles.button, styles.buttonSoft)}
            onClick={() =>
              copyWithNotice(
                rows.map((row) => `${row.label}: ${row.value}`).join('\n'),
                'Реквизиты скопированы',
              )
            }
          >
            Скопировать все
          </button>
        </div>
      )}
    </section>
  ),
);

AlfaRequisites.displayName = 'AlfaRequisites';
